import React from 'preact/compat';

export const ChatCommandButton: React.FC<{ src: string }> = ({ src }) => (
  <div
    className="chat-command-button"
    style={{ mask: `url(${src}) no-repeat center center`, backgroundColor: '#ccc', width: '22px', height: '22px' }}
  ></div>
);
